import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Statistic";

export const STATISTIC_PREFIX_URL = PREFIX_URL;

export const GetSaleStatisticEmployees = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleStatisticEmployees`, options);

export const GetSaleStatisticEmployeesMonthly = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleStatisticEmployeesMonthly`, options);

export const GetSaleStatisticProductCategories = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleStatisticProductCategories`, options);

export const GetSaleStatisticProductCategoriesMonthly = (options) =>
  GENERATE_URL(
    `${PREFIX_URL}/GetSaleStatisticProductCategoriesMonthly`,
    options
  );

export const GetSaleStatisticProducts = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleStatisticProducts`, options);

export const GetSaleStatisticProductsMonthly = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleStatisticProductsMonthly`, options);

export const GetSaleStatisticRegions = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleStatisticRegions`, options);

export const GetSaleStatisticRegionsMonthly = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleStatisticRegionsMonthly`, options);

export const GetSaleStatisticLocations = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleStatisticLocations`, options);

export const GetSaleStatisticLocationsMonthly = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleStatisticLocationsMonthly`, options);

export const GetSaleStatistics = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleStatistics`, options);

export const GetSaleStatisticsMonthly = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleStatisticsMonthly`, options);

export const GetTransactionSaleResults = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetTransactionSaleResults`, options);

export const GetSaleStatisticCustomers = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleStatisticCustomers`, options);

export const GetSaleStatisticCustomersMonthly = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSaleStatisticCustomersMonthly`, options);

export const GetEmployeeProductProfitStatistics = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetEmployeeProductProfitStatistics`, options);

export const GetEmployeeProductProfitStatisticsExcel = (options) =>
  GENERATE_URL(
    `${PREFIX_URL}/GetEmployeeProductProfitStatisticsExcel`,
    options
  );

export const GetCustomerSaleStatistics = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetCustomerSaleStatistics`, options);

export default {
  GetSaleStatisticEmployees,
  GetSaleStatisticProductCategories,
  GetSaleStatisticProducts,
  GetSaleStatisticRegions,
  GetSaleStatistics,
  GetTransactionSaleResults,
  GetSaleStatisticCustomers,
  GetSaleStatisticCustomersMonthly,
  GetSaleStatisticEmployeesMonthly,
  GetSaleStatisticProductCategoriesMonthly,
  GetSaleStatisticProductsMonthly,
  GetSaleStatisticRegionsMonthly,
  GetSaleStatisticLocations,
  GetSaleStatisticLocationsMonthly,
  GetSaleStatisticsMonthly,
  GetEmployeeProductProfitStatistics,
  GetEmployeeProductProfitStatisticsExcel,
  GetCustomerSaleStatistics,
};
